import React from "react";
import { Row, Col, Spin } from "antd";
import Avatar from "components/Avatar";
import Button from "components/Button";
import { StyledDivider } from "modules/Resume/Style/style";
import moment from "moment";
import {
  ResumeWrapper,
  ResumeCard,
  ResumeLeft,
  ResumeFileName,
  ResumeDate,
  ResumeActions,
  ResumeLimitNote, 
  UploadButtonWrapper
} from "./ResumeStyle";
import PDFBadge from "components/icons/PDFBadge";
import DOCBadge from "components/icons/DOCBadge";
import DownloadIcon from "components/icons/DownArrowIcon";
import DeleteIcon from "components/icons/Delete";
import PILBadge from "components/icons/PILBadge";
import ResumeDownload from "../Components/ResumeDownload";

const MAX_FILES = 6;

const ResumeSection = ({
  resumeFiles,
  loading,
  handleResumeUpload,
  deleteResumeFile,
  downloadResumeFile,
  systemResumeStudentData,
  resumeError,
  defaultResumeId,          
  onOpenUploadDrawer,
  studentUpdateAt,
  isResumeFrozen       
}) => {
  console.log(resumeFiles,'resumeFiles')
  return (
    <>
    
      <ResumeWrapper>
<Spin spinning={loading}>
  <ResumeWrapper>
        {/* Uploaded Files */}
      {resumeFiles.filter(item => item?.type !== "SYSTEM").map((item) => (
    <ResumeCard
      key={item.id}
      style={{
        background: item.id === defaultResumeId ? "#DAECFF" : "#FFFFFF",
      }}
    >
      <ResumeLeft>
        {item.fileFormat === "pdf" ? <PDFBadge /> : <DOCBadge />}

        <div>
          <ResumeFileName>{item.name}</ResumeFileName>
          <ResumeDate>Uploaded on {item.uploadedOn}</ResumeDate>
        </div>
      </ResumeLeft>
        {item.isPending && (
  <div
    style={{
      marginTop: "4px",
      fontSize: "12px",
      color: "#FA8C16",
      background: "#FFF7E6",
      padding: "2px 8px",
      borderRadius: "6px",
      display: "inline-block",
      fontWeight: 600,
    }}
  >
    Pending Approval
  </div>
)}
      <ResumeActions>
        <span onClick={() => downloadResumeFile(item)}>
          <DownloadIcon />
        </span>
        {(!isResumeFrozen || item.isPending) && (
        <span onClick={() => deleteResumeFile(item.id)}>
          <DeleteIcon />
        </span>
        )}
      </ResumeActions>
    </ResumeCard>
  ))}
   {resumeFiles
  .filter(item => item?.type === "SYSTEM")
  .map((item) => (
    <React.Fragment key="system-resume">
      {resumeFiles.length > 0 && <StyledDivider margin="0px 0" />}

      {/* System Generated Resume */}
      <ResumeCard
        style={{
          background: item?.isDefault ? "#DAECFF" : "#FFFFFF",
        }}
      >
        <ResumeLeft>
          <PILBadge />

          <div>
            <ResumeFileName>PIL Resume</ResumeFileName>
            <ResumeDate>Updated on {moment(item._raw.updateAt).format("DD/MM/YYYY")}</ResumeDate>
          </div>
        </ResumeLeft>

        <div
          style={{
            background: "#EEF0FF",
            padding: "6px 12px",
            borderRadius: "8px",
            fontSize: "12px",
            fontWeight: 600,
            color: "#6F80E3",
          }}
        >
          Sys. Generated
        </div>
        <ResumeActions>
          {systemResumeStudentData ? (
            <ResumeDownload studentData={systemResumeStudentData}>
              {({ url, loading, onBeforeDownload, fileName }) => (
                <a
                  href={url || undefined}
                  download={fileName}
                  onClick={onBeforeDownload}
                  style={{ display: 'inline-flex', alignItems: 'center' }}
                >
                  <DownloadIcon />
                </a>
              )}
            </ResumeDownload>
          ) : (
            <span onClick={null}>
              <DownloadIcon />
            </span>
          )}
        </ResumeActions>
      </ResumeCard>
    </React.Fragment>
))}


        {/* Hidden Input */}
        <input
          id="resume-upload-input"
          type="file"
          accept=".pdf"
          style={{ display: "none" }}
          onChange={handleResumeUpload}
        />
      


        {/* Upload New Resume Button */}
       {resumeFiles.length < MAX_FILES ? (
  <UploadButtonWrapper>
    <Button.Primary
      height={"38px"}
      width={"180px"}
      text={"Upload New Resume"}
      onClick={onOpenUploadDrawer}
    />
  </UploadButtonWrapper>
) : (
  <ResumeLimitNote>
    You’ve reached the limit of 5 resumes. <br />
    To upload a new file, please remove an existing resume.
  </ResumeLimitNote>
)}
{/* {resumeError && (
  <div style={{ color: "red", marginTop: "8px", fontSize: "13px" }}>
    {resumeError}
  </div>
)} */}
</ResumeWrapper>
</Spin>
      </ResumeWrapper>
    </>
  );
};

export default ResumeSection;
